export const en = {
    'add-entity': 'Add',
    'agency-clients': 'List of agency clients',
    'all-clients': 'All clients',
    campaigns: 'Campaigns',
    'client-representatives': 'Registered representatives',
    creatives: 'Creatives for smart banners',
    edit: 'Editing',
    feeds: 'Feeds',
    info: 'Information',
    'internationalization-interface': 'Localization interface',
    library: 'Library',
    'minus-keywords-library': 'Negative keywords',
    'mobile-apps': 'Mobile apps',
    'order-reports': 'Request reports',
    'phrases-positions-monitoring': 'Monitoring changes in ad position',
    'price-packages-grid': 'Packages',
    recommendations: 'Recommendations',
    reports: 'Reports',
    'retargeting-and-audiences': 'Retargeting & Audiences',
    'statistic-by-all-campaigns': 'Statistics for all campaigns',
    'statistic-by-all-old-campaigns': 'Statistics for old campaigns in units',
    tools: 'Tools',
    'turbo-pages': 'Turbo Page Builder',
    'upload-documents': 'Load documents'
};
